<template>
  <div>
    <nav-bar class="home-nav">
      <div slot="center">黄科大校园体育</div>
    </nav-bar>

    <van-tabs v-model="activeName">
      <!--      <van-tab title="学生登陆" name="student" to="/login/student"></van-tab>-->
      <van-tab title="教师登陆" name="teacher" to="/login/teacher"></van-tab>
      <van-tab title="管理员登陆" name="admin" to="/login/admin"></van-tab>
    </van-tabs>
    <keep-alive>
      <router-view></router-view>
    </keep-alive>
  </div>
</template>

<script>
import NavBar from "components/common/navbar/NavBar";
import Vue from 'vue';
import {Tab, Tabs} from 'vant';

import {StuLogin, TeaLogin, AdmLogin} from "../../network/login";
import {Dialog} from 'vant';

Vue.use(Tab);
Vue.use(Tabs);
export default {
  name: "Login",
  data() {
    return {
      activeName: "student"
    };
  },
  mounted() {
    this.$bus.$on('UserLogin', (value) => {
      switch (this.activeName) {
        case "student":
          this.StuLogin(value);
          break;
        case "teacher":
          this.TeaLogin(value);
          break;
        case "admin":
          this.AdmLogin(value);
          break;
        // console.log(this.$store.state.islogin);
      }
    });
  },
  methods: {
    showFailLoginDialog(value = '账号或密码错误') {
      Dialog.alert({
        title: '登陆失败',
        message: value
      }).then(() => {
        // on close
      });
    },
    loginOp(res) {
      // console.log(res);
      //
      // this.$router.replace("/home");
    },
    StuLogin(value) {
      StuLogin(value.a, value.b).then(res => {
        if (res.islogin) {
          this.$store.commit('logined');
          this.$store.commit('inituser', res);
          this.$cookies.set("islogin", true, '6m');
          this.$cookies.set("user", res.user, '6m');
          this.$cookies.set("info", res.info, '6m');
          this.$router.replace("/home");
          // setTimeout(() => location.reload(), 1000000)
        } else {
          this.showFailLoginDialog();
        }
      })
    },
    TeaLogin(value) {
      TeaLogin(value.a, value.b).then(res => {
        console.log(res)
        if (res.islogin) {
          this.$store.commit('logined');
          this.$store.commit('inituser', res);
          this.$cookies.set("islogin", true, '6m');
          this.$cookies.set("user", res.user, '6m');
          this.$cookies.set("info", res.info, '6m');
          this.$router.replace("/home");
          // setTimeout(() => location.reload(), 1000000)
        } else {
          this.showFailLoginDialog(res.fail);
        }
      })
    },
    AdmLogin(value) {
      AdmLogin(value.a, value.b).then(res => {
        if (res.islogin) {
          this.$store.commit('logined');
          this.$store.commit('inituser', res);
          this.$cookies.set("islogin", true, '6m');
          this.$cookies.set("user", res.user, '6m');
          this.$cookies.set("info", res.info, '6m');
          this.$router.replace("/home");
          // setTimeout(() => location.reload(), 1000000)
          // location.reload();
        } else {
          this.showFailLoginDialog(res.fail);
        }
      })
    }
  },
  components: {
    NavBar
  }
}
</script>

<style scoped>
.home-nav {
  /*background-color: var(--color-tint);*/
  /*background-image: linear-gradient(#e66465, #9198e5);*/

  background: #c6ffdd; /* fallback for old browsers */
  background: -webkit-linear-gradient(to right, rgb(198, 255, 221), rgb(251, 215, 134), rgb(247, 121, 125));
  /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(to right, rgb(198, 255, 221), rgb(251, 215, 134), rgb(247, 121, 125));
  /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
  color: #fff;

  /*在使用浏览器原生滚动时，为了让导航不跟随一起滚动*/
  /*position: fixed;*/
  /*left: 0;*/
  /*right: 0;*/
  /*top: 0;*/
  /*z-index: 9;*/
}

</style>
